import * as constantes from '../../constantes';
import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import { Form, Button, Grid, Message , Checkbox } from 'semantic-ui-react';
import { registerLocale } from "react-datepicker";
import es from 'date-fns/locale/es';
import { estados } from './Estados.js'; 
import RowAlternativa from '../controls/RowAlternativa'; 

import auth0Client from '../Auth/Auth'; 
const server = constantes.REST_API_PRIVATE;

registerLocale('es', es)

export default class Form01 extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            caso:props.caso,
            errors: [],
            listaPreguntas: [],
            preguntaActual:null,
            casoPreguntaActual:null,
            error: null,
            fechaUno: new Date(),
            fechaDos: new Date(),
            valorUnico: null,
            dataFiltro: {} ,
            listaCheks:null,
            option : null ,
            redirect: false , 
            urlRedirect : null 
        };
        this._back = this._back.bind(this);
        this._onChange = this._onChange.bind(this);
        this._onChangeParaSelect = this._onChangeParaSelect.bind(this);
        this._onRadioSelect = this._onRadioSelect.bind(this); 
        this._limpiarRadio = this._limpiarRadio.bind(this);  
        this._onCheck = this._onCheck.bind(this);
        this._onCheck2 = this._onCheck2.bind(this);
        this._handlerChangeFechaFunction = this._handlerChangeFechaFunction.bind(this);
        this._handlerChangeTextFunction = this._handlerChangeTextFunction.bind(this);
        this._validate = this._validate.bind(this);
    }
    
    componentDidMount() {
        let METHODNAME = 'componentDidMount - ';
        console.log(METHODNAME + 'INI');

        auth0Client.isExpired();
        
        console.log(METHODNAME + 'Lista Preguntas cargadas = ' + this.state.listaPreguntas.length );
        this.cargarPreguntaInicial();

        console.log(METHODNAME + 'FIN');
    }

    UNSAFE_componentWillMount() {
        let METHODNAME = 'UNSAFE_componentWillMount - ';
        console.log(METHODNAME + 'INI');

        console.log(METHODNAME + 'FIN');
    }

    _addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    _back() {
        let METHODNAME = '_back - ';
        console.log(METHODNAME + 'INI');
        //TODO analizar la pregunta actrual, este back debe regresar en la lista de preguntas 

        let preguntaAnterior = null ;
        if( this.state.preguntaActual ){
            preguntaAnterior = this.state.preguntaActual.anterior ;
        }

        if(preguntaAnterior){
            console.log(METHODNAME + 'preguntaAnterior = ' + preguntaAnterior.idPregunta );
            this.setState({
                isLoaded: true,
                preguntaActual : preguntaAnterior
            });
        }else{
            console.log(METHODNAME + 'su punto de inicio es INICIADO');
            this.props.back(estados.INICIADO)
        }
        
    }

    /**
     * RAdio 
     * Otros 
     * @param {*} e 
     * @param {*} param1 
     */
    _onChange(e, { name, value }) {
        let METHODNAME = '_onChange - ';
        console.log(METHODNAME + 'name = ' + name + '; value = ' + value + '; id = ' + e.target.id + '; tipoControl= '  + e.target.name );

        if( name === 'valorUnico'){
            let isSelected = e.target.checked;
            console.log(METHODNAME + 'isSelected = ' + isSelected);
            this.state.preguntaActual.alternativas.forEach(function(opcion) {

                //console.log(METHODNAME + 'e.target.id = ' + e.target.id + ', checked='+ (opcion.name+'_'+opcion.alternativaId) );

                if( e.target.id === opcion.name+'_'+opcion.alternativaId ){
                    opcion.checked = isSelected;
                    //console.log(METHODNAME + 'Opcion Unica = ' + opcion.label + ', checked='+ opcion.checked);
                    //return true;
                }else{
                    opcion.checked = false;
                    //console.log(METHODNAME + 'Opcion Unica = ' + opcion.label + ', checked='+ opcion.checked);
                }
            });
        } if( name === 'option'){

            console.log(METHODNAME + 'option: name = ' + name + '; value = ' + value + '; id = ' + e.target.id );

            this.state.preguntaActual.alternativas.forEach(function(opcion) { 
                if( value === opcion.value ){
                    opcion.checked = true; 
                }else{
                    opcion.checked = false; 
                }
            });
            /*
            this.setState({
                casoPreguntaActual.alternativa.alternativaId : value
            });
            */
            this.state.casoPreguntaActual.alternativa.alternativaId = value;

        }  else {

        }

        this.setState({
            [name]: value
        });
    }

    /**
     * Para input type=SELECT
     * @param {*} event 
     * @param {*} data 
     */
     _onChangeParaSelect( event,data ) { //e, { name, value }
        let METHODNAME = '_onChangeParaSelect - ';

        let name = data.name;  
        console.log(METHODNAME + 'name = ' + name  + '; value = ' + data.value );

        //let alternativaSeleccionada = null ; 
        let tempPreguntaActual = this.state.preguntaActual;
        tempPreguntaActual.alternativas.forEach(function(alternativa) {
            
            if( 'select_'+alternativa.alternativaId === name ){
                alternativa.value = data.value; 
            }

        }); 
        this.setState({
            preguntaActual : tempPreguntaActual
        });
        
    }
    
    /**
     * Para CHECKBOX valor principal 
     * @param {*} e 
     */
    _onCheck(e) {
        let METHODNAME = '_onCheck - ';
        let isChecked = e.target.checked;      
        this.state.preguntaActual.alternativas.some(function(opcion) {
            if( e.target.id === opcion.name+'_'+opcion.alternativaId ){
                console.log(METHODNAME + 'Actualizar: ' + e.target.id + '; isChecked: ' + isChecked );
                opcion.checked = isChecked;
                return true;
            }
        });
        this.setState({
            listaCheks: 1
        });
    }
    /**
     * Para RadioButtom, seleccion unica 
     * @param {*} e 
     */
     _onRadioSelect(e) {
        let METHODNAME = '_onRadioSelect - ';
        console.log(METHODNAME + 'INI');

        let isChecked = e.target.checked;      
        this.state.preguntaActual.alternativas.some(function(opcion) {
            if( e.target.id === opcion.name+'_'+opcion.alternativaId ){
                console.log(METHODNAME + 'Seleccionado ' + e.target.id );
                opcion.checked = isChecked;
            }else{
                //DESMARCAR A LOS DEMAS
                opcion.checked = false;
            }
        });
        this.setState({
            listaCheks: 1
        });
    }

    _limpiarRadio(e) {
        let METHODNAME = '_limpiarRadio - ';
        //console.log(METHODNAME + 'INI');

        //console.log(METHODNAME + 'listaCheck Seleccionado = ' + e.target.id + '; isChecked = ' + isChecked  );        
        this.state.preguntaActual.alternativas.some(function(opcion) {
            opcion.checked = false;
        });
        //necesario para que refresque la pantalla 
        this.setState({
            listaCheks: 1
        });
        //console.log(METHODNAME + 'FIN');
    }

    /**
     * Para CHECKBOX valor secundario 
     * @param {*} e 
     */
     _onCheck2(e ) {
        let METHODNAME = '_onCheck2 - ';
        let isChecked = e.target.checked;
        this.state.preguntaActual.alternativas.some(function(opcion) {
            //console.log(METHODNAME + 'e.target.id: ' + e.target.id + ', id{}='+ '2_'+opcion.name+'_'+opcion.alternativaId ) ;
            if( e.target.id === '2_'+opcion.name+'_'+opcion.alternativaId ){
                opcion.checked2 = isChecked;
                console.log(METHODNAME + 'POST listaCheck: ' + opcion.label + ', checked='+ opcion.checked2);
                return true;
            }
        });
        this.setState({
            listaCheks: 1
        });
    }

    _handlerChangeFechaFunction( date , name ){
        let METHODNAME = '_handlerChangeFechaFunction - ';
        //console.log( METHODNAME + 'name = ' + name  + '; Fecha = ' + date );

        //Actualixar JSON de alternativas
        this.state.preguntaActual.alternativas.forEach(function(opcion) { 
            if( name === opcion.name ){
                opcion.value = date;
                console.log(METHODNAME + 'name = ' + name + ', value='+ date );
            }
        });

        //Actualizar pantalla con setState 
        this.setState({
            [name]: date
        });
    }

    _handlerChangeTextFunction( e ){
        //let METHODNAME = '_handlerChangeTextFunction - ';
        //console.log(METHODNAME + 'INI');

        let valor = e.target.value;
        let name = e.target.name;

        //console.log(METHODNAME + 'name = ' + name + ', value='+ valor );

        this.state.preguntaActual.alternativas.forEach(function(opcion) { 
            if( name === opcion.name ){
                opcion.value = valor;
                //console.log(METHODNAME + 'name = ' + name + ', value='+ valor );
            }
        });

        this.setState({
            [name]: valor
        });

    }

    /**
     * Metodo ejecutado cuando se da clic en el boton NEXT 
     * viene a ser el que valide todo lo que hace el submit del form.
     * @param {*} e 
     */
     _validate(e) {
        let METHODNAME = '_validate - ';
        console.log(METHODNAME + 'INI');

        e.preventDefault();
        
        this.setState({
            isLoaded: false
        });

        this.sendForm01();
        
        console.log(METHODNAME + 'FIN');
    }
    
    async cargarPreguntaInicial(){
        let METHODNAME = 'cargarPreguntaInicial - ';
        console.log(METHODNAME + 'INI');

        console.log(METHODNAME + 'Lista Preguntas cargadas = ' + this.state.listaPreguntas.length );
        
        let url = server+`/preguntas/validacion/${this.state.caso.casoId}/`;

        fetch( 
            url , {
            method: 'GET',
            headers:{
                'Accept':'application/json',
                'Content-Type':'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
            }
        })
        .then(res => res.json())
        .then(
            (result) => {
                console.log(METHODNAME + 'CARGADA LA PRIMERA PREGUNTA');
                console.log(METHODNAME + 'PRIMERA PREGUNTA = ' + result.casoPregunta.pregunta.idPregunta + ' - ' + result.casoPregunta.pregunta.nombrePregunta);
                
                let lTemp =  this.state.listaPreguntas;
                lTemp.push( result.casoPregunta.pregunta );

                if( result.casoPregunta.alternativa == null ){
                    result.casoPregunta.alternativa = { alternativaId : 0 };
                }else{
                    console.log(METHODNAME + 'opt seleccionada ' +  result.casoPregunta.alternativa.alternativaId );
                }

                this.setState({
                    isLoaded: true,
                    preguntaActual : result.casoPregunta.pregunta,
                    casoPreguntaActual : result.casoPregunta,
                    listaPreguntas: lTemp
                });

            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
                console.log(METHODNAME + 'error = ' + error );
                this.setState({
                    isLoaded: true,
                    error
                });
            }
        )
        console.log(METHODNAME + 'FIN');
    }
    
    /*
    componentDidUpdate(){
        let METHODNAME = 'componentDidUpdate - ';
        console.log(METHODNAME + 'INI');

        console.log(METHODNAME + 'FIN');
    }
    */
    /**
     * https://github.com/anil-sidhu/react-17/tree/update-list
     * https://medium.com/@nutanbhogendrasharma/step-by-step-consume-rest-api-in-react-application-48388f6c4d9c
     * @param {*} fechaUno 
     * @param {*} fechaDos 
     * @param {*} apelacionEnFecha 
     */
    async sendForm01( ) {
        let METHODNAME = 'sendForm01 - ';

        // Aqui tengo que enviar los datos dinamicamente obtenidos 
        // pueden ser de las cajas de las fechas, o de los radiobutons 
        // esto dependera de la pregunta obtenida y sus alternativas 
        let tipoPantallaId = this.state.preguntaActual.tipoPantalla.tipoPantallaId ; 
        console.log(METHODNAME + 'tipoPantallaId = ' + tipoPantallaId ); 

        let dataForm = null;
        //Fecha
        if( tipoPantallaId === 1 ){
            dataForm = {
                idCaso : this.state.caso.casoId ,
                preguntaActual : this.state.preguntaActual,
                fUno : this.state.fechaUno,
                fDos : this.state.fechaDos
            }
        }
        //Opcion unica
        if( tipoPantallaId === 2 ){
            let alternativaSeleccionada = null;
            /*this.state.preguntaActual.alternativas.forEach(function(opcion) {
                console.log(METHODNAME + 'Opcion unica: ' + opcion.label + ', selected='+ opcion.checked); 
            });*/            
            dataForm = {
                idCaso : this.state.caso.casoId ,
                preguntaActual : this.state.preguntaActual,
                alternativa : alternativaSeleccionada,
                valor : this.state.valorUnico
            }
        }
        //Fin ETAPA
        if( tipoPantallaId === 5 ){
            dataForm = {
                idCaso : this.state.caso.casoId ,
                preguntaActual : this.state.preguntaActual,
                valor : ''
            }
        }
        // checklist 
        if( tipoPantallaId === 6 ){
            dataForm = {
                idCaso : this.state.caso.casoId ,
                preguntaActual : this.state.preguntaActual,
                valor : ''
            }
        }
        // resuelto 
        if( tipoPantallaId === 7 ){
            /*dataForm = {
                idCaso : this.state.caso.casoId ,
                preguntaActual : this.state.preguntaActual,
                valor : ''
            }*/
        }

        //SELECT
        if( tipoPantallaId === 8 ){
            dataForm = {
                idCaso : this.state.caso.casoId ,
                valor : this.state.option,
                preguntaActual : this.state.preguntaActual  
            }
        }

        // checklist 
        if( tipoPantallaId === 9 ){
            dataForm = {
                idCaso : this.state.caso.casoId ,
                preguntaActual : this.state.preguntaActual,
                valor : ''
            }
        }

        // fecha compleja 
        if( tipoPantallaId === 10 ){
            dataForm = {
                idCaso : this.state.caso.casoId ,
                preguntaActual : this.state.preguntaActual,
                valor : ''
            }
        }

        // Opción Única Sin Selección
        if( tipoPantallaId === 11 ){
            dataForm = {
                idCaso : this.state.caso.casoId ,
                preguntaActual : this.state.preguntaActual,
                valor : ''
            }
        }
       
        // console.warn(METHODNAME + "data form = ",dataForm);
        
        //let url = server+`/validacion/auto/${this.state.caso.casoId}/`;
        let url =  `${server}/preguntas/validacion/${this.state.caso.casoId}/`;

        const json = await fetch( url , {
            method: 'POST',
            headers:{
                'Accept':'application/json',
                'Content-Type':'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
            },
            body:JSON.stringify(dataForm)
        }).then((result) => {

            //console.log(METHODNAME + 'RESPUESTA OBTENIDA');

            result.json().then((resp) => {

                //console.log(METHODNAME + 'Procesando respuesta. resultado = ' + resp.resultado );
                
                /*
                // Aqui en lugar de cambiar de FASE / ESTADO, solo pintar una nueva pregunta 
                // complicado, ya que hay que hacer que recargue la pantalla e invocar al metodo 
                // que trae la pregunta pero ahora tendria que traer la siguiente pregunta 
                */ 

                if( resp.resultado === 'CONTINUAR' || resp.resultado === 'NULIDAD' ){
                    
                    //console.warn(METHODNAME + 'SIGUIENTE PREGUNTA = ' + resp.casoPregunta );
                    //console.log(METHODNAME + 'pregunta nueva = ' +  resp.casoPregunta.pregunta.idPregunta + ' - ' + resp.casoPregunta.pregunta.nombrePregunta);
                    
                    if( resp.casoPregunta.alternativa == null ){
                        resp.casoPregunta.alternativa = { alternativaId : 0 };
                    }

                    resp.casoPregunta.pregunta.anterior = this.state.preguntaActual;
                    let lTemp =  this.state.listaPreguntas;
                    
                    //Modificacion para ordenar los controles segun la posicion
                    resp.casoPregunta.pregunta.alternativas = resp.casoPregunta.pregunta.alternativas.sort((a, b) => (a.posicion > b.posicion ? 1 : -1))

                    lTemp.push( resp.casoPregunta.pregunta );
                    this.setState({
                        isLoaded: true,
                        preguntaActual : resp.casoPregunta.pregunta,
                        casoPreguntaActual : resp.casoPregunta,
                        listaPreguntas: lTemp,
                        error: null
                    });
              
                }else if( resp.resultado === 'APROBADO' || resp.resultado === 'RESUELTO' || resp.resultado === 'RECHAZADO'){

                    console.warn( METHODNAME + 'Redirect: ' + resp.resultado + ', casoId = ' +  resp.caso.casoId );
                    this.setState({
                        isLoaded: true,
                        redirect: true ,
                        urlRedirect : '/resultadoCaso/' + resp.caso.casoId 
                    }); 

                }else {

                    this.setState({
                        isLoaded: true,
                        error: { message : resp.error }
                    });
                }
               
            }).catch((error) => { 
                console.error(METHODNAME +  'PRIMER CATCH - interno = ' + error)
            });


        }).catch((error) => { 
            console.error(METHODNAME +  'SEGUNDO  CATCH - interno = ' + error)
        });
       
        return json ;
    }

    render() {
        /** 
         * https://reactjs.org/docs/conditional-rendering.html 
         * 
         */
        const { error, isLoaded, preguntaActual , casoPreguntaActual , redirect } = this.state;
        
        if (!isLoaded) {
            return <div>Loading...</div>;
        } else if ( redirect ) {
            console.warn('redirect hacia ' + this.state.urlRedirect );
            return <Navigate to={this.state.urlRedirect} />;
        } else {

            return(
            <Form>
                
                { this.state.errors.length > 0 &&
                <Message negative>
                    <p>{this.state.errors.join('. ')}</p>
                </Message>
                }

                { this.state.error != null &&
                    <Message 
                        color='red'
                        icon='times'
                        header='ERROR:'
                        content={error.message}/>
                }

                <Form.Field>
                    
                    <h2>
                        {preguntaActual.nombrePregunta} 
                        <span style={ {'color' : 'white' } }>({preguntaActual.posicion}) </span>  
                    </h2>
                    <h3>
                        <div dangerouslySetInnerHTML={{ __html: preguntaActual.explicacionPregunta }} />
                    </h3>

                    <Grid columns={1} stackable>

                    { preguntaActual.nota &&
                        <Grid.Row columns={1}>
                            <Grid.Column>
                                <Message  color='blue'
                                    icon='attention'
                                    header='Nota:'
                                    content={preguntaActual.nota}
                                />
                            </Grid.Column> 
                        </Grid.Row>
                    }

                    { ( preguntaActual.tipoPantalla.tipoPantallaId===2 ) &&
                        preguntaActual.alternativas.map(item => (
                            <RowAlternativa key={'row_alt_'+item.alternativaId}
                                item={item}
                                options={preguntaActual.options}
                                onChange={this._handlerChangeFechaFunction}
                                onChangeText={this._handlerChangeTextFunction}
                                onChangeRadio={this._onRadioSelect}
                                onChangeSelect={this._onChangeParaSelect} />
                        ))
                    }

                    { preguntaActual.tipoPantalla.tipoPantallaId === 5 && 

                        preguntaActual.alternativas.map(item => (
                            <RowAlternativa key={'row_alt_'+item.alternativaId}
                                item={item}
                                name ={item.name}
                                options={preguntaActual.options}
                                onChange={this._handlerChangeFechaFunction}
                                onChangeText={this._handlerChangeTextFunction}
                                onChangeRadio={this._onRadioSelect}/>
                        ))

                    }
                    
                    { preguntaActual.tipoPantalla.tipoPantallaId === 6 &&
                        preguntaActual.alternativas.map(item => (
                            <Grid.Row columns={1} key={item.alternativaId}> 
                            <Form.Field key={item.alternativaId}>
                                <Checkbox toggle
                                    id={item.name+'_'+item.alternativaId}
                                    label={item.label}
                                    name={item.name}
                                    value={item.value}
                                    checked={item.checked}
                                    onChange={e => this._onCheck(e)}
                                />
                            </Form.Field>
                            </Grid.Row>
                        ))
                    }

                    { ( preguntaActual.tipoPantalla.tipoPantallaId === 8 ) &&

                        preguntaActual.alternativas.map(item => (
                            <RowAlternativa key={'row_alt_'+item.alternativaId}
                                item={item}
                                name ={item.name}
                                options={preguntaActual.options}
                                onChange={this._handlerChangeFechaFunction}
                                onChangeText={this._handlerChangeTextFunction}
                                onChangeRadio={this._onRadioSelect}
                                onChangeSelect={this._onChangeParaSelect} />
                        ))
 
                    }

                    { ( preguntaActual.tipoPantalla.tipoPantallaId===9 ) &&
                        preguntaActual.alternativas.map(item => (
                            <RowAlternativa key={'row_alt_'+item.alternativaId}
                                item={item}
                                name ={item.name}
                                handleChange={this._onCheck}
                                handleChange2={this._onCheck2} 
                                onChange={this._handlerChangeFechaFunction}
                                onChangeText={this._handlerChangeTextFunction}
                                onChangeRadio={this._onRadioSelect}
                                onChangeSelect={this._onChangeParaSelect}/>
                        ))
                    }

                    { ( preguntaActual.tipoPantalla.tipoPantallaId === 10 ) && 
                        preguntaActual.alternativas.map(item => (
                            <RowAlternativa key={'row_alt_'+item.alternativaId}
                                item={item}
                                name ={item.name}
                                options={preguntaActual.options}
                                onChange={this._handlerChangeFechaFunction}
                                onChangeText={this._handlerChangeTextFunction}
                                onChangeRadio={this._onRadioSelect}
                                onChangeSelect={this._onChangeParaSelect} />
                        ))
                    }

                    { preguntaActual.tipoPantalla.tipoPantallaId === 11 &&
                        preguntaActual.alternativas.map(item => (
                            <RowAlternativa key={'row_alt_'+item.alternativaId}
                                item={item}
                                name ={item.name}
                                options={preguntaActual.options}
                                onChange={this._handlerChangeFechaFunction}
                                onChangeText={this._handlerChangeTextFunction}
                                onChangeRadio={this._onRadioSelect}
                                onChangeSelect={this._onChangeParaSelect} />
                        ))
                    }

                    { preguntaActual.tipoPantalla.tipoPantallaId === 11 &&
                        <Grid.Column>
                            <Button primary onClick={this._limpiarRadio}>Desmarcar todos</Button>
                        </Grid.Column>
                    }
                    </Grid>
 
                </Form.Field>
                
                <Grid>
                <Grid.Column floated='left' width={5}>
                    <Button secondary onClick={this._back}>Volver</Button>
                </Grid.Column>
                <Grid.Column floated='right' width={5}>
                    <Button primary onClick={this._validate}>Siguiente</Button>
                </Grid.Column>
                </Grid>
            </Form>
            );

        }
 
    }
}

